"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
_Object$defineProperty(exports, "EhrLoginLogout", {
  enumerable: true,
  get: function () {
    return _EhrLoginLogout.EhrLoginLogout;
  }
});
var _EhrLoginLogout = require("./EhrLoginLogout");